import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
	noContentText: {
		textAlign: "center"
	}
}));

export default function NoContentText(props) {
	const classes = useStyles();

	return (
		<Grid container justify="center">
			<Grid item>
				<Typography 
					id="no-content-text"
					className={classes.noContentText} 
					variant="h5"
				>
					{props.msg}
				</Typography>
			</Grid>
		</Grid>
	);
}
